export const base64 = {
  encode: (str: string): string => {
    const bytes = new TextEncoder().encode(str)
    let binary = ''
    const chunkSize = 0x8000
    for (let i = 0; i < bytes.length; i += chunkSize) {
      binary += String.fromCodePoint(...bytes.subarray(i, i + chunkSize))
    }
    return btoa(binary)
  },
  decode: (str: string): string => {
    const binary = atob(str)
    const bytes = new Uint8Array(binary.length)
    for (let i = 0; i < binary.length; i++) {
      bytes[i] = binary.codePointAt(i) ?? 0
    }
    return new TextDecoder().decode(bytes)
  },
}

// let's use this instead of Base62 (url native encoding) to have less code
export const base64url = {
  encode: (data: string | Uint8Array): string => {
    let binary = ''
    if (typeof data === 'string') {
      const bytes = new TextEncoder().encode(data)
      const chunkSize = 0x8000
      for (let i = 0; i < bytes.length; i += chunkSize) {
        binary += String.fromCodePoint(...bytes.subarray(i, i + chunkSize))
      }
    } else {
      const chunkSize = 0x8000
      for (let i = 0; i < data.length; i += chunkSize) {
        binary += String.fromCodePoint(...data.subarray(i, i + chunkSize))
      }
    }
    return btoa(binary)
      .replaceAll('+', '-')
      .replaceAll('/', '_')
      .replaceAll('=', '')
  },
  decode: (str: string): string => {
    let base64str = str.replaceAll('-', '+').replaceAll('_', '/')
    while (base64str.length % 4) {
      base64str += '='
    }
    return base64.decode(base64str)
  },
}

export async function blobToBase64(blob: Blob) {
  const arrayBuffer = await blob.arrayBuffer()

  let binary = ''
  const bytes = new Uint8Array(arrayBuffer)
  const chunkSize = 0x8000 // handle large files safely: Maximum call stack size exceeded" errors that can occur when spreading too many bytes into String.fromCharCode()
  for (let i = 0; i < bytes.length; i += chunkSize) {
    binary += String.fromCodePoint(...bytes.subarray(i, i + chunkSize))
  }

  return btoa(binary)
}

export function base64ToBlob(base64String: string, type: string) {
  const byteCharacters = atob(base64String)
  const byteArrays: number[] = []
  for (let i = 0; i < byteCharacters.length; i++)
    byteArrays.push(byteCharacters.codePointAt(i) ?? 0)

  const byteArray = new Uint8Array(byteArrays)
  return new Blob([byteArray], { type })
}
